import React from 'react';
import {Box, Dialog, Typography} from '@mui/material';
import {getSettingsColors, settingsInputStyles} from './SettingsDesign';

export function SettingsDialog({sx = [], ...props}) {
    return <Dialog {...props} sx={[{
        '& .MuiDialog-paper': {
            ...settingsInputStyles, bgcolor: theme => getSettingsColors(theme).card, color: 'text.primary',
            backgroundImage: 'none', borderRadius: {xs: 0, sm: '16px'}, boxShadow: 'none',
            border: theme => theme.palette.mode === 'dark' ? '1px solid' : 0, borderColor: 'divider',
            '& .MuiOutlinedInput-notchedOutline': {border: 0},
            '& .MuiTypography-root': {whiteSpace: 'normal'},
            '& .MuiButton-root': {borderRadius: '8px'},
            '& .MuiChip-root': {borderRadius: '6px'}
        },
        '& .MuiDialogTitle-root': {fontSize: 22, fontWeight: 700, textAlign: 'left', m: 0, px: {xs: 2, sm: 3}, pt: 3, pb: 2, border: 0},
        '& .MuiDialogContent-root': {px: {xs: 2, sm: 3}, pt: 1, pb: 2, scrollbarGutter: 'stable'},
        '& .MuiDialogActions-root': {px: {xs: 2, sm: 3}, py: 2, gap: 1, border: 0}
    }, ...(Array.isArray(sx) ? sx : [sx])]}/>;
}

export function SettingsDialogDescription({children}) {
    return <Typography component="p" sx={{fontSize: 13, fontWeight: 400, color: 'text.secondary', mt: 0.75}}>{children}</Typography>;
}

export function SettingsFormSection({title, description, children, sx}) {
    return <Box sx={[{mt: 3}, sx]}>
        <Typography sx={{fontSize: 14, fontWeight: 600, mb: 0.75}}>{title}</Typography>
        {description && <Typography sx={{fontSize: 13, color: 'text.secondary', mb: 1.5}}>{description}</Typography>}
        {children}
    </Box>;
}

export const settingsSelectionListStyles = {
    bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '10px', p: 0.5,
    maxHeight: 320, overflow: 'auto', position: 'relative',
    '& .MuiListItemButton-root': {borderRadius: '7px', px: 1.5, py: 0.75},
    '& .MuiListItemIcon-root': {minWidth: 36},
    '& .MuiListItemText-primary': {fontSize: 14, overflowWrap: 'anywhere'},
    '& .MuiListItemText-secondary': {fontSize: 12},
    '& .MuiDivider-root': {borderColor: 'divider', mx: 1.5}
};
